import { useFormContext } from 'react-hook-form'
import { ToggleInput } from '~/components/Form'

type FormValues = {
  message: string
}

type AvailabilityToggleProps = {
  availabilityContent: string
  onChange: (checked: boolean) => void
}

export const AvailabilityToggle = ({
  availabilityContent,
  onChange
}: AvailabilityToggleProps) => {
  const { setValue, register, watch } = useFormContext<FormValues>()

  return (
    <ToggleInput
      name="isAvailabilityRequest"
      label="Demande de disponibilité"
      register={register}
      watch={watch}
      setValue={setValue}
      onChange={(checked) => {
        if (checked) {
          setValue('message', availabilityContent, { shouldDirty: true })
        }
        onChange(checked)
      }}
    />
  )
}
